'use strict';

const mmWidgets = require('./mm-widgets');
require('./dispatched-event-toggle-widget');

mmWidgets.fn.fileInfoValueToggleWidget = function (pageController) {
	return mmWidgets.each(this, function () {
		const eventValueDataKey = 'data-mm-file-info-toggle',
			valueAttrName = 'data-mm-file-info-value',
			toggleClassDataAttrName = 'data-mm-file-info-toggle-class';

		return this.dispatchedEventToggleWidget(pageController, ['fileInfo'], eventValueDataKey, valueAttrName, toggleClassDataAttrName);

	});

};
